import React from "react";
import { Table as TableIcon, LineChart, DollarSign, Percent, FileText, ChevronDown } from "lucide-react";

// Bottom tab bar for switching between Graph / Table / P&L $ / P&L % /
// Contract Value views. For now Graph is the only "live" view — the others
// emit `onChange(id)` but the parent will keep rendering the chart. This
// matches the OptionStrat visual footprint without requiring us to build
// every view in one pass.

const TABS = [
  { id: "table",    label: "Table",          icon: TableIcon },
  { id: "graph",    label: "Graph",          icon: LineChart },
  { id: "pnl_d",    label: "Profit / Loss $",  icon: DollarSign },
  { id: "pnl_p",    label: "Profit / Loss %",  icon: Percent },
  { id: "contract", label: "Contract Value", icon: FileText },
];

const ViewTabs = ({ active = "graph", onChange = () => {} }) => (
  <div
    className="flex items-center gap-1 bg-[#0E1A30] border border-white/10 rounded-xl px-2 py-1.5 flex-wrap"
    data-testid="forge-view-tabs"
  >
    {TABS.map((t) => {
      const isActive = t.id === active;
      const Icon = t.icon;
      return (
        <button
          key={t.id}
          type="button"
          onClick={() => onChange(t.id)}
          data-testid={`forge-view-tab-${t.id}`}
          className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-[11px] uppercase tracking-[0.16em] transition ${
            isActive
              ? "bg-[#3B82F6] text-white font-medium"
              : "text-white/55 hover:text-white hover:bg-white/[0.05]"
          }`}
        >
          <Icon className="w-3 h-3" /> {t.label}
        </button>
      );
    })}
    <button
      type="button"
      data-testid="forge-view-tab-more"
      className="ml-auto inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-[11px] uppercase tracking-[0.16em] text-white/55 hover:text-white hover:bg-white/[0.05] transition"
    >
      More <ChevronDown className="w-3 h-3" />
    </button>
  </div>
);

export default ViewTabs;
